import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import { DeletePanelPost, EditPanelPost } from "../../../../Config/API/panel";
import Loader from "../../../../common/cards/Loader";
import Tl from "../../../../common/cards/TPTimelineCard";
import NoData from "../../../../common/cards/noData";
import { Row, Spin } from "antd";
import { useFetchProfilePosts } from "../../../../common/hooks/useFetchProfilePosts";
import { useCurrentPage } from "../../../../common/hooks/useCurrentPage";
import { useCreatePost } from "../../../../common/hooks/useCreatePost";
import UploadPostcard from "../../../../common/cards/UploadPostcard";

const DiscussionPanel = () => {
  const [POSTS, setPOSTS] = useState([]);
  const [loadMorePosts, setLoadMorePosts] = useState(false);

  const { posts, postloading, setPage, totalPages, page, fetchTime } =
    useFetchProfilePosts("panel");
  const { other } = useCurrentPage();
  const {
    uploadloading,
    IMAGE,
    VIDEO,
    setimage,
    setvideo,
    text,
    setText,
    uploadingMedia,
    setuploadingMedia,
    CreatePost,
    setLuploading,
    Luploading
  } = useCreatePost(setPOSTS, "Panel", POSTS);

  const observer = useRef();
  const isThrottled = useRef(false);
  const timer = useRef();

  useEffect(() => {
    const fetchPosts = async () => {
      setPOSTS((prevPosts) => [
        ...(Array.isArray(prevPosts) ? prevPosts : []),
        ...(Array.isArray(posts) ? posts : [])
      ]);

      // Adjust timeout based on fetch time, adding some buffer (e.g., 100ms)
      const timeoutDuration = Math.max(fetchTime + 100, 500); // Minimum of 500ms

      timer.current = setTimeout(() => setLoadMorePosts(false), timeoutDuration);
    };
    fetchPosts();
    return () => clearTimeout(timer.current);
  }, [posts, fetchTime]);

  const lastPostElementRef = useCallback(
    (node) => {
      if (postloading || isThrottled.current) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setLoadMorePosts(true);
            isThrottled.current = true;
            setTimeout(() => {
              isThrottled.current = false;
            }, 100);
            if (page < totalPages) setPage((prevPage) => prevPage + 1);
          }
        },
        {
          root: null,
          threshold: 0.1
        }
      );
      if (node) observer.current.observe(node);
    },
    [postloading, page, totalPages]
  );

  return (
    <Row className={`mobileto`}>
      <Fragment>
        {other ? null : (
          <UploadPostcard
            uploadingMedia={uploadingMedia}
            setuploadingMedia={setuploadingMedia}
            setText={setText}
            text={text}
            IMAGE={IMAGE}
            setimage={setimage}
            VIDEO={VIDEO}
            setvideo={setvideo}
            onPost={CreatePost}
            loading={uploadloading}
            setLuploading={setLuploading}
            Luploading={Luploading}
          />
        )}
      </Fragment>
      {postloading ? (
        <Loader />
      ) : POSTS?.length > 0 ? (
        <>
          {POSTS?.map((data, index) => {
            if (POSTS?.length === index + 1) {
              return (
                <Tl
                  Editing
                  key={data?._id || index}
                  data={data}
                  setPOSTs={setPOSTS}
                  editpost={EditPanelPost}
                  deletepost={DeletePanelPost}
                  posts={POSTS}
                  index={index}
                  ref={lastPostElementRef}
                />
              );
            } else {
              return (
                <Tl
                  Editing
                  key={data?._id || index}
                  data={data}
                  setPOSTs={setPOSTS}
                  editpost={EditPanelPost}
                  deletepost={DeletePanelPost}
                  posts={POSTS}
                  index={index}
                />
              );
            }
          })}
          {/* Loader for more posts */}
          {loadMorePosts && page < totalPages && (
            <div style={{ textAlign: "center", margin: "20px", width: "100%" }}>
              <Spin tip="Loading more posts..." style={{ color: "black", fontSize: "12px" }} />
            </div>
          )}
        </>
      ) : (
        <NoData />
      )}
    </Row>
  );
};

export default DiscussionPanel;
